import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Button } from '@arkestro/arkestro-design-system';

import FloatingPanel from '@components/on_board/FloatingPanel/FloatingPanel';
import Footer from '@components/on_board/Footer/Footer';
import { VendorOnboardContext } from '@components/on_board/vendor/VendorOnboardProvider/VendorOnboardProvider';
import Carousel from '@components/shared/Carousel/Carousel';
import { getSteps } from '@components/on_board/vendor/VendorWelcomeGuide/WelcomeCarousel/steps';

import WelcomeScreen from './WelcomeScreen/WelcomeScreen';

const COL_SIZE_HASH_MAP = {
  carousel: { lg: 20, md: 20, sm: 22, xl: 12 },
  welcome: { lg: 12, md: 14, sm: 16, xl: 8, xs: 24 }
};

const COMPLETE_BTN_STYLE = {
  bottom: -65,
  left: '50%',
  marginLeft: -100,
  position: 'absolute',
  textAlign: 'center',
  width: 200
};

const VendorWelcomeGuide = () => {
  const { t } = useTranslation('common');
  const steps = getSteps(t);
  const [isLastStep, setIsLastStep] = useState(false);

  const handleChange = (stepNum, stepCount) => {
    setIsLastStep(stepNum === (stepCount - 1));
  };

  return (
    <VendorOnboardContext.Consumer>
      {({ currentWelcomeStep, currentStepName, updateOnboardStep, setProperty }) => (
        <FloatingPanel colSizes={COL_SIZE_HASH_MAP[currentWelcomeStep]}>
          <div className='' id='vendor-welcome-wizard'>
            {currentWelcomeStep === 'welcome' && <WelcomeScreen setWelcomeStep={setProperty} />}
            {currentWelcomeStep === 'carousel' && (
              <Carousel onChange={handleChange} steps={steps} />
            )}
          </div>
          <Footer onSkip={isLastStep ? undefined : () => updateOnboardStep(currentStepName)} />
          {isLastStep && (
            <div style={COMPLETE_BTN_STYLE}>
              <Button onClick={() => updateOnboardStep(currentStepName)} type="primary">
                {t('general.complete')}
              </Button>
            </div>
          )}
        </FloatingPanel>
      )}
    </VendorOnboardContext.Consumer>
  );
};

export default VendorWelcomeGuide;
